var map = {
	"./1.png": "A1tS",
	"./1@2x.png": "8Bxp",
	"./2@2x.png": "h4Bu",
	"./3.png": "ZK0V",
	"./3@2x.png": "dWCb",
	"./4.png": "q/uz",
	"./4@2x.png": "PUhe",
	"./5.png": "PgLh",
	"./6.png": "0DhX",
	"./7.png": "DBM3",
	"./8.png": "KNp8",
	"./9.png": "rqk2",
	"./App_badge_downloadAndroid.png": "7Rns",
	"./App_badge_downloadApple.png": "lduI",
	"./Icon_BraveWave.png": "tzmE",
	"./Icon_Charge.png": "EA4i",
	"./Icon_HCI@.png": "OSA6",
	"./Icon_phone.png": "bXv7",
	"./Milestones.png": "xRnU",
	"./QR.jpg": "3k6D",
	"./QR_tiktok.png": "9fOE",
	"./Video-Medium.png": "DvDL",
	"./WeChat-purple.png": "I4vc",
	"./WeChat.png": "L6SR",
	"./Webo-purple.png": "UYJc",
	"./Webo.png": "f+YE",
	"./about7.png": "7XrM",
	"./about8.png": "zJtS",
	"./banner_neural.jpg": "TVAE",
	"./email-purple.png": "SREG",
	"./email.png": "wF+D",
	"./founder_photo.jpg": "2Tnj",
	"./headband_white.png": "HTli",
	"./icon1.png": "HWEK",
	"./icon2.png": "HosE",
	"./icon3.png": "y9FJ",
	"./icon4.png": "K3X3",
	"./icon_Copy.png": "aVBa",
	"./icon_more.png": "nypa",
	"./logo(商标未注册).png": "84qU",
	"./logo.png": "7Otq",
	"./logo1(商标未注册).png": "aT/H",
	"./logo1.png": "TrFT",
	"./logo_black.png": "K6bQ",
	"./lume_product.png": "fIJe",
	"./moon.png": "2xte",
	"./panbrain.png": "5UTW",
	"./phone.png": "UqHI",
	"./play.png": "KBZJ",
	"./product_lotus2_hero.jpg": "WZJi",
	"./product_lotus2_small.png": "pP4I",
	"./product_lotus2r_hero.jpg": "v2o2",
	"./product_lotus2r_small.png": "9gtp",
	"./qr_down.png": "6bSg",
	"./renzheng_logo.png": "uqc4",
	"./scenes_icon_businessTrip.png": "TCci",
	"./scenes_icon_holiday.png": "tBqa",
	"./scenes_icon_office.png": "2Ffg",
	"./scenes_icon_recommend.png": "e8lw",
	"./scenes_icon_study.png": "PGED",
	"./scenes_icon_superman.png": "7Hau",
	"./sleep.png": "A/0B",
	"./tech12.png": "0GEd",
	"./test.png": "2FlR",
	"./tiktok-purple.png": "yZgS",
	"./tiktok.png": "GkVo",
	"./tired.png": "Fmo/",
	"./tmall_qr.png": "6VLG",
	"./up.png": "WY0H",
	"./wave.png": "Ea9E",
	"./wearing_scene.jpg": "mR1L",
	"./wechat_qrcode.png": "cKGo",
	"./work.png": "dh9O"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1